import { ChatMessage } from '../api/types';

export interface ConversationTurn {
  id: string;
  timestamp: string;
  userMessage: ChatMessage | null;
  assistantMessages: ChatMessage[];
}

export function groupMessagesIntoTurns(
  messages: ChatMessage[],
): ConversationTurn[] {
  const turns: ConversationTurn[] = [];
  let current: ConversationTurn | null = null;

  for (const msg of messages) {
    if (msg.role === 'user') {
      if (current) turns.push(current);
      current = {
        id: msg.id,
        timestamp: msg.timestamp,
        userMessage: msg,
        assistantMessages: [],
      };
    } else {
      if (!current) {
        current = {
          id: msg.id,
          timestamp: msg.timestamp,
          userMessage: null,
          assistantMessages: [],
        };
      }
      current.assistantMessages.push(msg);
    }
  }

  if (current) turns.push(current);
  return turns;
}

export function formatTurnTimestamp(isoString: string): string {
  const date = new Date(isoString);
  const now = new Date();
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const time = `${hours}:${minutes}`;

  const isToday =
    date.getFullYear() === now.getFullYear() &&
    date.getMonth() === now.getMonth() &&
    date.getDate() === now.getDate();

  if (isToday) return `Hoje ${time}`;

  const yesterday = new Date(now);
  yesterday.setDate(yesterday.getDate() - 1);
  const isYesterday =
    date.getFullYear() === yesterday.getFullYear() &&
    date.getMonth() === yesterday.getMonth() &&
    date.getDate() === yesterday.getDate();

  if (isYesterday) return `Ontem ${time}`;

  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  return `${day}/${month} ${time}`;
}
